import { GetReturnLossByIdResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { ReturnLossQueryKeys } from '@/modules/promotion/keys'
import { getReturnLossById } from '../../services'

export default function useQueryGetReturnLossById(
	id: string,
	props?: UseBaseQueryOptions<GetReturnLossByIdResponse>,
) {
	return useQuery({
		queryKey: [ReturnLossQueryKeys.GetReturnLossById, id],
		queryFn: () => getReturnLossById(id),
		...props,
	})
}
